var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-naf',{attrs:{"navItems":_vm.items,"logo-src":_vm.getLogoCooperativa,"logo-mini-src":_vm.getLogoCooperativa}})
}
var staticRenderFns = []

export { render, staticRenderFns }